import {Inject, Injectable, Type} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {DialogWidth} from '@q9elements/ui-kit/common';
import {IDialogData} from '../../../custom-metadata-view/dialogs/models/create-new-view.interface';
import {DeleteNodeBaseDialogComponent} from './delete-node-base-dialog.component';
import {DELETE_NODE_BASE_DIALOG_COMPONENT} from './delete-node-base-dialog.token';

@Injectable({
  providedIn: 'root'
})
export class DeleteNodeBaseDialogService {
  constructor(
    private dialog: MatDialog,
    @Inject(DELETE_NODE_BASE_DIALOG_COMPONENT)
    public DeleteDialogComponent: Type<DeleteNodeBaseDialogComponent>
  ) {}

  public getDeleteNodeDialog(dialogData: IDialogData): MatDialogRef<DeleteNodeBaseDialogComponent> {
    return this.dialog.open(this.DeleteDialogComponent, {
      width: DialogWidth.SM,
      data: dialogData
    });
  }
}
